import script from "./CarInent.vue?vue&type=script&lang=ts&setup=true"
export * from "./CarInent.vue?vue&type=script&lang=ts&setup=true"

import "./CarInent.vue?vue&type=style&index=0&id=727ef7ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-727ef7ba"]])

export default __exports__